<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: bisque;">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Admin Reports</span>
    </mat-toolbar>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="content-subtext">
        <p>View and Download Reports</p>
        <mat-divider></mat-divider>
      </div>
    </div>
    <!-- Add Content Here -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="content-header">
                <p>
                  <mat-toolbar>
                    <!-- Total Applications -->
                    <mat-form-field appearance="outline">
                      <mat-label>
                        <mat-icon>list</mat-icon>Year
                      </mat-label>
                      <mat-select [(ngModel)]="year">
                        <mat-option *ngFor="let year of years" [value]="year.year"
                          (click)="fetchApplicantList(year.year)">
                          {{year.year}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <span class="example-spacer"></span>
                    <mat-form-field appearance="outline" class="search-field">
                      <mat-label>Search Reports .....</mat-label>
                      <input matInput placeholder="Ex. Search report .....">
                    </mat-form-field>
                    <button mat-button>Search</button>
                  </mat-toolbar>
                </p>
              </div>
              <mat-divider></mat-divider>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="dashboard-header">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <mat-card>
                      <mat-accordion class="example-headers-align">
                        <!-- Report of All Applications-->
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              All Applications
                            </mat-panel-title>
                            <mat-panel-description>
                              View Reports of All Applications
                              <mat-icon>account_circle</mat-icon>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <table class="table">
                            <thead>
                              <tr>
                                <th>ID.</th>
                                <th>Report Type</th>
                                <th>No. of Applications</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Total Applications-->
                              <tr>
                                <td>1.</td>
                                <td>All Applications</td>
                                <td>{{totalApplicants}}</td>
                                <td><button class="download" mat-button (click)="downloadReport('All')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Degree Applications-->
                              <tr>
                                <td>2.</td>
                                <td>Ghanaian Applications</td>
                                <td>{{ghanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadResidentBasedReport('R')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Diploma Applications-->
                              <tr>
                                <td>3.</td>
                                <td>Foreign Applications</td>
                                <td>{{nonGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadResidentBasedReport('NR')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Certificate Applications-->
                              <tr>
                                <td>4.</td>
                                <td>Female Applications</td>
                                <td>{{femaleApplicants}}</td>
                                <td><button mat-button (click)="downloadGenderBasedReport('F')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Accepted Applications-->
                              <tr>
                                <td>5.</td>
                                <td>Male Applications</td>
                                <td>{{maleApplicants}}</td>
                                <td><button mat-button (click)="downloadGenderBasedReport('M')">Download Report
                                  </button></td>
                              </tr>
                            </tbody>
                          </table>
                        </mat-expansion-panel>
                        <!-- Report of All Degree Applications-->
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              Degree Applications
                            </mat-panel-title>
                            <mat-panel-description>
                              View Reports of All Degree Applications
                              <mat-icon>account_circle</mat-icon>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <table class="table">
                            <thead>
                              <tr>
                                <th>ID.</th>
                                <th>Report Type</th>
                                <th>No. of Applications</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Total Applications-->
                              <tr>
                                <td>1.</td>
                                <td>All Degree Applications</td>
                                <td>{{totalDegreeApplicants}}</td>
                                <td><button class="download" mat-button (click)="downloadReport('Degree')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Degree Applications-->
                              <tr>
                                <td>2.</td>
                                <td>Ghanaian Applications</td>
                                <td>{{degreeGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeResidentBasedReport('Degree','R')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Diploma Applications-->
                              <tr>
                                <td>3.</td>
                                <td>Foreign Applications</td>
                                <td>{{degreeNonGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeResidentBasedReport('Degree','NR')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Certificate Applications-->
                              <tr>
                                <td>4.</td>
                                <td>Female Applications</td>
                                <td>{{degreeFemaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeWithGenderBasedReport('Degree','F')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Accepted Applications-->
                              <tr>
                                <td>5.</td>
                                <td>Male Applications</td>
                                <td>{{degreeMaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeWithGenderBasedReport('Degree','M')">Download Report
                                  </button></td>
                              </tr>
                            </tbody>
                          </table>
                        </mat-expansion-panel>
                        <!-- Report of All Diploma Applications-->
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              Diploma Applications
                            </mat-panel-title>
                            <mat-panel-description>
                              View Reports of All Diploma Applications
                              <mat-icon>account_circle</mat-icon>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <table class="table">
                            <thead>
                              <tr>
                                <th>ID.</th>
                                <th>Report Type</th>
                                <th>No. of Applications</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Total Applications-->
                              <tr>
                                <td>1.</td>
                                <td>All Diploma Applications</td>
                                <td>{{totalDiplomaApplicants}}</td>
                                <td><button class="download" mat-button (click)="downloadReport('Diploma')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Degree Applications-->
                              <tr>
                                <td>2.</td>
                                <td>Ghanaian Applications</td>
                                <td>{{diplomaGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeResidentBasedReport('Diploma','R')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Diploma Applications-->
                              <tr>
                                <td>3.</td>
                                <td>Foreign Applications</td>
                                <td>{{diplomaNonGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeResidentBasedReport('Diploma','NR')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Certificate Applications-->
                              <tr>
                                <td>4.</td>
                                <td>Female Applications</td>
                                <td>{{diplomaFemaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeWithGenderBasedReport('Diploma','F')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Accepted Applications-->
                              <tr>
                                <td>5.</td>
                                <td>Male Applications</td>
                                <td>{{diplomaMaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeWithGenderBasedReport('Diploma','M')">Download Report
                                  </button></td>
                              </tr>
                            </tbody>
                          </table>
                        </mat-expansion-panel>
                        <!-- Report of All Certificate Applications-->
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              Certificate Applications
                            </mat-panel-title>
                            <mat-panel-description>
                              View Reports of All Certificate Applications
                              <mat-icon>account_circle</mat-icon>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <table class="table">
                            <thead>
                              <tr>
                                <th>ID.</th>
                                <th>Report Type</th>
                                <th>No. of Applications</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Total Applications-->
                              <tr>
                                <td>1.</td>
                                <td>All Certificate Applications</td>
                                <td>{{totalCertificateApplicants}}</td>
                                <td><button class="download" mat-button (click)="downloadReport('Certificate')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Degree Applications-->
                              <tr>
                                <td>2.</td>
                                <td>Ghanaian Applications</td>
                                <td>{{certificateGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeResidentBasedReport('Certificate','R')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Diploma Applications-->
                              <tr>
                                <td>3.</td>
                                <td>Foreign Applications</td>
                                <td>{{certificateNonGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeResidentBasedReport('Certificate','NR')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Certificate Applications-->
                              <tr>
                                <td>4.</td>
                                <td>Female Applications</td>
                                <td>{{certificateFemaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeWithGenderBasedReport('Certificate','F')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Accepted Applications-->
                              <tr>
                                <td>5.</td>
                                <td>Male Applications</td>
                                <td>{{certificateMaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationTypeWithGenderBasedReport('Certificate','M')">Download Report
                                  </button></td>
                              </tr>
                            </tbody>
                          </table>
                        </mat-expansion-panel>
                        <!-- Report of All Accepted Applications-->
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              Accepted Applications
                            </mat-panel-title>
                            <mat-panel-description>
                              View Reports of All Accepted Applications
                              <mat-icon>account_circle</mat-icon>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <table class="table">
                            <thead>
                              <tr>
                                <th>ID.</th>
                                <th>Report Type</th>
                                <th>No. of Applications</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Total Applications-->
                              <tr>
                                <td>1.</td>
                                <td>All Accepted Applications</td>
                                <td>{{acceptedApplicants}}</td>
                                <td><button class="download" mat-button (click)="downloadReport('ACCEPTED')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Degree Applications-->
                              <tr>
                                <td>2.</td>
                                <td>Ghanaian Applications</td>
                                <td>{{acceptedGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusResidentBasedReport('ACCEPTED','R')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Diploma Applications-->
                              <tr>
                                <td>3.</td>
                                <td>Foreign Applications</td>
                                <td>{{acceptedNonGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusResidentBasedReport('ACCEPTED','NR')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Certificate Applications-->
                              <tr>
                                <td>4.</td>
                                <td>Female Applications</td>
                                <td>{{acceptedFemaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusWithGenderBasedReport('ACCEPTED','F')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Accepted Applications-->
                              <tr>
                                <td>5.</td>
                                <td>Male Applications</td>
                                <td>{{acceptedMaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusWithGenderBasedReport('ACCEPTED','M')">Download Report
                                  </button></td>
                              </tr>
                            </tbody>
                          </table>
                        </mat-expansion-panel>
                        <!-- Report of All Rejected Applications-->
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              Rejected Applications
                            </mat-panel-title>
                            <mat-panel-description>
                              View Reports of All Rejected Applications
                              <mat-icon>account_circle</mat-icon>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <table class="table">
                            <thead>
                              <tr>
                                <th>ID.</th>
                                <th>Report Type</th>
                                <th>No. of Applications</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Total Applications-->
                              <tr>
                                <td>1.</td>
                                <td>All Rejected Applications</td>
                                <td>{{rejectedApplicants}}</td>
                                <td><button class="download" mat-button (click)="downloadReport('REJECTED')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Degree Applications-->
                              <tr>
                                <td>2.</td>
                                <td>Ghanaian Applications</td>
                                <td>{{rejectedGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusResidentBasedReport('REJECTED','R')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Diploma Applications-->
                              <tr>
                                <td>3.</td>
                                <td>Foreign Applications</td>
                                <td>{{rejectedNonGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusResidentBasedReport('REJECTED','NR')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Certificate Applications-->
                              <tr>
                                <td>4.</td>
                                <td>Female Applications</td>
                                <td>{{rejectedFemaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusWithGenderBasedReport('REJECTED','F')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Accepted Applications-->
                              <tr>
                                <td>5.</td>
                                <td>Male Applications</td>
                                <td>{{rejectedMaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusWithGenderBasedReport('REJECTED','M')">Download Report
                                  </button></td>
                              </tr>
                            </tbody>
                          </table>
                        </mat-expansion-panel>
                        <!-- Report of All Waitlisted Applications-->
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              Waitlisted Applications
                            </mat-panel-title>
                            <mat-panel-description>
                              View Reports of All Waitlisted Applications
                              <mat-icon>account_circle</mat-icon>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <table class="table">
                            <thead>
                              <tr>
                                <th>ID.</th>
                                <th>Report Type</th>
                                <th>No. of Applications</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Total Applications-->
                              <tr>
                                <td>1.</td>
                                <td>All Waitlisted Applications</td>
                                <td>{{waitlistedApplicants}}</td>
                                <td><button class="download" mat-button (click)="downloadReport('WAITLISTED')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Degree Applications-->
                              <tr>
                                <td>2.</td>
                                <td>Ghanaian Applications</td>
                                <td>{{waitlistedGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusResidentBasedReport('WAITLISTED','R')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Diploma Applications-->
                              <tr>
                                <td>3.</td>
                                <td>Foreign Applications</td>
                                <td>{{waitlistedNonGhanaianApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusResidentBasedReport('WAITLISTED','NR')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Certificate Applications-->
                              <tr>
                                <td>4.</td>
                                <td>Female Applications</td>
                                <td>{{waitlistedFemaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusWithGenderBasedReport('WAITLISTED','F')">Download Report
                                  </button></td>
                              </tr>
                              <!-- Accepted Applications-->
                              <tr>
                                <td>5.</td>
                                <td>Male Applications</td>
                                <td>{{waitlistedMaleApplicants}}</td>
                                <td><button mat-button (click)="downloadApplicationStatusWithGenderBasedReport('WAITLISTED','M')">Download Report
                                  </button></td>
                              </tr>
                            </tbody>
                          </table>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </mat-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>